export default {
  select_profile_title: 'src.components.login.profile_selection.title',
  select_profile_description:
    'src.components.login.profile_selection.description',
  account_name: 'src.components.login.profile_selection.account_name',
  fsap_id: 'src.components.login.profile_selection.fsap_id',
  account_type: 'src.components.login.profile_selection.account_type',
  address: 'src.components.login.profile_selection.address',
  set_as_default: 'src.components.login.profile_selection.set_as_default',
  continue_button: 'src.components.login.profile_selection.continue_button',
  loading_profiles: 'src.components.login.profile_selection.loading_profiles',
};
